import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ForwardIcon from '@mui/icons-material/Forward';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {Inc,Dataset,Owner,Book,BookSearchCondition} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Alert from './Alert';
import Yesno from './Yesno';
import Loading from './Loading';
import BookListSearch from './BookListSearch';
import StoreImg from './StoreImg';
import Title from './Title';
import AppBank from './AppBank';

interface BookListProps {
	owner:Owner,
	bank:AppBank,
}
let p:number = 1;
const defPages:Dataset[] = [];
const defBooks:Book[] = [];
const defCheckedIds:number[] = [];

const BookList = (props:BookListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
	const classes = useStyles();
	const [pages,setPages] = useState(defPages);
    const [states,setStates] = useState({
		books:defBooks,
		checkedIds:defCheckedIds,
		allChecked:false,
        isLoading:true,
		pager:null,
		yesno:"",
		alert:"",
        cond:Inc.defaultBookSearchCondition(),
    });
    const search = (cond:BookSearchCondition,first?:boolean)=>{
		setStates({...states,"isLoading":true});
		if( first )     {
			p = 1;
		}
		window.scrollTo(0,0);
        Ajax.search("book/list",cond,p,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({...states,books:res.books,cond:cond,pager:res.pager,isLoading:false,checkedIds:[],allChecked:false,yesno:""});
            } else {
                setStates({...states,"isLoading":false,yesno:""});
            }
        });
	}
	const jump = (to:number)=>{
		//send(values,p);
		p = to;
		search(states.cond);
	}
	const checkId = (id:number)=>{
		if( states.checkedIds.includes(id) ){
			let ids = states.checkedIds;
			const index = ids.findIndex((v) => v===id);
			ids.splice(index,1);
			setStates({...states,"checkedIds":ids});
		} else {
			setStates({...states,"checkedIds":states.checkedIds.concat(id)});
		}
	}
	const checkAllId = ()=>{
		if( states.allChecked ){
			setStates({...states,"checkedIds":[],"allChecked":false});
		} else {
			let ids:number[] = [];
			for( let i=0 ; i<states.books.length ; i++ ){
				ids.push( states.books[i].item_id );
			}
			setStates({...states,"checkedIds":ids,"allChecked":true});
		}
	}
	const remove = ()=>{
		//※公開の戯曲のみ
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"戯曲を選択して下さい"});
		} else {
			let error = false;
			for( let i=0 ; i<states.books.length ; i++ ){
				if( states.checkedIds.includes(states.books[i].item_id) ){
					if( states.books[i].status!=="0" ){
						error = true;
					}
				}
			}
			if( error ){
				setStates({...states,"alert":"公開している戯曲は削除できません"});
			} else {
				setStates({...states,"yesno":"remove"});
			}
		}
	}
	const secret = ()=>{
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"戯曲を選択して下さい"});
		} else {
			setStates({...states,"yesno":"secret"});
		}
	}
	const yes = ()=>{
		if( states.yesno==="secret" ){
			Ajax.send("book/private",{item_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond);
				}
			});
		}
		if( states.yesno==="remove" ){
			Ajax.send("book/hide",{item_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond);
				}
			});
		}
	}
	const no = ()=>{
		setStates({...states,"yesno":""});
	}
	const alertClose = ()=>{
		setStates({...states,"alert":""});
	}
	useEffect( ()=>{

	},[]);

	let yesnoMes = "";
	if( states.yesno!=="" ){
		if( states.yesno==="remove" ){
			yesnoMes = "選択した戯曲を削除します。\n本当によろしいですか？";
		}
		if( states.yesno==="secret" ){
			yesnoMes = "選択した戯曲を非公開にします。\nよろしいですか？";
		}
	}

	const sleep = false;

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	return (
		<div id="book_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="戯曲" second="（電子書籍）" icon="book"/>
						{sleep &&
							<div style={{color:"#FF0000",border:"1px solid #FF0000",padding:"1em",marginBottom:"1em"}}>
								戯曲（電子書籍）はリニューアルのため現在サービスを一時停止しております。<br/>
								2019/11/07頃に再開される見込みです。<br/>
							</div>
						}
                        <div style={{marginBottom:"2em"}}>
                            架空ストアに登録してある戯曲（電子書籍）の商品一覧です。条件を指定して商品を検索することもできます。<br/>
                            新しい戯曲を登録する場合は、「戯曲を登録」ボタンをクリックして下さい。<br/>
							<Hidden mdUp implementation="js">
								<div style={{width:"100%",maxWidth:"160px",marginRight:"0",marginLeft:"auto"}}>
								<FormControl fullWidth={true} style={{margin:"1em 0"}}>
								{sleep ? (
									<Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}><AddIcon/>戯曲を登録</Button>
								):(
									<Link to="/book/new"><Button variant="contained" color="primary" style={{width:"100%"}}><AddIcon/>戯曲を登録</Button></Link>
								)}
								</FormControl>
								</div>
							</Hidden>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCellNowrap}>
										<Checkbox
											checked={states.allChecked}
											onClick={()=>checkAllId()}
											color="primary"
											className={classes.listCheckbox}
										/>									
										
									</TableCell>
									<TableCell className={classes.tableHeadNowrap} align='center'>商品</TableCell>
                                    <Hidden lgDown implementation="js">
                                        <TableCell className={classes.tableHeadNowrap} align='center'>画像</TableCell>
                                        <TableCell className={classes.tableHeadNowrap} align='center'>単価</TableCell>
									</Hidden>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableHeadNowrap} align='center'>試し読み</TableCell>
                                        <TableCell className={classes.tableHeadNowrap} align='center'>販売許可</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableHeadNowrap} align='center'>状態表示</TableCell>
                                    <TableCell className={classes.tableHeadNowrap}>　</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                        {states.books.map( (book:Book,index:number)=>{
                            const key = "book"+index;
							const to = "/book/"+String(book.item_id);
							const v = states.checkedIds.includes(book.item_id);
                            return (
                                <TableRow key={key}>
                                    <TableCell className={classes.tableCellDense} style={{width:'2em'}}>
										<Checkbox
						checked={v}
						value={String(book.item_id)}
						onClick={()=>checkId(book.item_id)}
						color="primary"
						className={classes.listCheckbox}
										/>
                                    </TableCell>
									<TableCell className={classes.tableCellDense}>
                                        <span className={classes.itemId}>ID:{book.item_id}</span>　
                                        <Hidden smUp implementation="js">
                                            <br/>
                                        </Hidden>
                                        {book.book_name}<br/>
										{book.book_version !== "" &&
										<div className="with_page_name">ver.{book.book_version}</div>
										}
										<Hidden smUp implementation="js">
											<Divider/>
                                            {Tools.comma(book.price)}円
                                            {book.num_limit >0 &&
                                            <span> / 試 {book.num_limit}P</span>
                                            }
										</Hidden>

									</TableCell>
                                    <Hidden lgDown implementation="js">
                                        <TableCell className={classes.tableCellNowrap} style={{width:'5em'}}><StoreImg owner_id={props.owner.owner_id} img_id={book.img_id} thumb={false} className="imgBookList"/></TableCell>
                                        <TableCell className={classes.tableCellNowrap} align="right">{Tools.comma(book.price)}円</TableCell>
									</Hidden>
									<Hidden smDown implementation="js">
                                        <TableCell className={classes.tableCellNowrap} align="right" style={{width:'6em'}}>
                                            {book.num_limit >0 ? (
                                            <span>{book.num_limit}P</span>
                                            ):(
                                            <span style={{color:"#CCCCCC"}}>なし</span>
                                            )}
                                        </TableCell>
                                        <TableCell className={classes.tableCellNowrap} align="right" style={{width:'4em'}}>
                                            {Tools.colorLabel("book_admit",book.admit_id,book.admit)}
                                        </TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableCellNowrap} align="center" style={{width:'4em'}}>
                                        <Hidden smUp implementation="js">
                                            {Tools.colorLabel("book_admit",book.admit_id,book.admit)}<br/>
										</Hidden>
                                        {Tools.colorLabel("item_status",book.status,book.status_label)}
                                    </TableCell>
                                    <TableCell className={classes.tableCellNowrap} align="right" style={{width:'2em'}}>
									{sleep ? (
										<IconButton aria-label="edit" className={classes.primary} disabled={true}><ForwardIcon style={{color:"#CCCCCC"}}/></IconButton>
									):(
										<Link to={to}><IconButton aria-label="edit" className={classes.primary}><ForwardIcon/></IconButton></Link>
									)}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                            </TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="登録・修正" size={2}/>
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
							{sleep ? (
								<Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}><AddIcon/>戯曲を登録</Button>
							):(
								<Link to="/book/new"><Button variant="contained" color="primary" style={{width:"100%"}}><AddIcon/>戯曲を登録</Button></Link>
							)}
							</FormControl>
							<Divider style={{marginBottom:"1em"}}/>
						</Hidden>
						<FormControl fullWidth={true}>
							<div className={classes.withIcon} style={{marginBottom:"0.5em"}}><CheckBoxIcon/>チェックした商品を</div>
							<FormGroup row>
								<Button variant="outlined" color="secondary" size='small' onClick={secret} disabled={states.checkedIds.length===0}><VisibilityOffIcon/>非公開にする</Button>
								<Button variant="contained" color="secondary" size='small' onClick={remove} disabled={states.checkedIds.length===0}><DeleteForeverIcon/>削除する</Button>
							</FormGroup>
						</FormControl>
					</Paper>

                    <Paper className={classes.paper}>
                        <BookListSearch pages={pages} update={search} bank={props.bank} bankKey={"savedBookListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
			<Yesno mes={yesnoMes} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Alert mes={states.alert} close={alertClose} isOpen={states.alert!==""}/>
		</div>
	);
}

export default BookList;
